import styled from 'styled-components';

import { FormFooter, Title } from '@xsolla/ui-core';

export const TitleHeader = styled(Title)`
  text-align: center;
  justify-content: center;
`;

export const DeleteFormContent = styled.div`
  padding: 43px 30px 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  p {
    text-align: center;
  }
`;

export const IconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 11px;
`;

export const InputWrapper = styled.div`
  width: 100%;
  margin-top: 16px;
`;

export const InputTitle = styled.div`
  ${(p) => p.theme.typography.graphikFontFamily};
  color: ${(p) => p.theme.colors.muted};
  text-align: left;
`;

export const SuccessFormFooter = styled(FormFooter)`
  margin-top: 0;
`;
